import { render, staticRenderFns } from "./CreateProject.vue?vue&type=template&id=c4e5486a"
import script from "./CreateProject.vue?vue&type=script&lang=js"
export * from "./CreateProject.vue?vue&type=script&lang=js"
import style0 from "./CreateProject.vue?vue&type=style&index=0&id=c4e5486a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports